<app-main-header [breadcrumbs]="breadcrumbs"></app-main-header>

<ion-content>
  <div
    class="d-flex justify-content-center align-items-center h-75"
    *ngIf="!ready || !equipmentReady"
  >
    <div class="spinner-border text-warning" role="status">
      <span class="visually-hidden">
        {{ 'remote_control' | translation }}: {{ 'auth_loading' | translation }}
      </span>
    </div>
  </div>

  <div *ngIf="ready && equipmentReady">
    <div class="container-fluid my-2">
      <div class="row">
        <div class="col-12">
          <div class="card my-3">
            <div class="card-body">
              <h6 class="fs-2 m-0">
                {{ 'remote_control' | translation }}
              </h6>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 order-2 order-md-1">
          <div class="card mb-3 mb-md-2">
            <div class="card-body">
              <app-remote-control
                [class]="'p-0'"
                [terminal_vid]="terminal.vid"
                [terminal_connected]="isEquipmentConnected()"
                (buttonQueue)="onButtonQueue($event)"
                (lastSendedButton)="onLastSendedButton($event)"
              ></app-remote-control>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 order-1 order-md-2">
          <div class="card mb-3 mb-md-2">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  {{
                    'remote_control_description' | translation | sanitizeText
                  }}
                </div>
              </div>
              <div class="row mt-3 d-none d-md-block">
                <div class="col-12">
                  <h6 class="fs-2">
                    {{ 'remote_control_queue' | translation }}
                  </h6>
                  <div class="queued-buttons-container">
                    <div class="queued-buttons-content">
                      <div
                        class="queued-button"
                        *ngFor="let queued of buttonQueue"
                      >
                        <img [src]="queued.src" [alt]="queued.label" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <h6 class="fs-2">
                    {{ 'remote_control_last_sended' | translation }}
                  </h6>
                  <div class="last-sended-button-container">
                    <div class="last-sended-button" *ngIf="lastSendedButton">
                      <img
                        [src]="lastSendedButton.src"
                        [alt]="lastSendedButton.label"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
